import { bemComponent } from '../../../../utils/app';

export const Header = bemComponent('fullscreen-header');
export const Item = bemComponent('fullscreen-header__item');
